import { render, staticRenderFns } from "./title_cat.vue?vue&type=template&id=acbb75d0&scoped=true&"
import script from "./title_cat.vue?vue&type=script&lang=js&"
export * from "./title_cat.vue?vue&type=script&lang=js&"
import style0 from "./title_cat.vue?vue&type=style&index=0&id=acbb75d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbb75d0",
  null
  
)

export default component.exports